import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/product';
const SHOW_MS = 5200;
const HIDE_MS = 7000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const first = window.setTimeout(() => setVisible(true), 4000);
    return () => window.clearTimeout(first);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(i => (i + 1) % buyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? SHOW_MS : HIDE_MS);
    return () => window.clearTimeout(timer);
  }, [visible, dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed inset-x-3 bottom-3 z-50 flex justify-center sm:inset-x-auto sm:left-4 sm:justify-start" aria-live="polite" data-id="element-154" data-mp="165pjw8a9imau">
      <AnimatePresence data-id="element-155" data-mp="1151xjzwzatmy">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-[21rem] items-center gap-2.5 rounded-xl border-2 border-cyan bg-navy px-3 py-2.5 shadow-[0_10px_30px_-8px_rgba(8,120,232,0.6)] ring-2 ring-auto/50" data-id="element-156" data-mp="1fuhbugfbp6lr">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cyan/20 text-cyan" data-id="element-157" data-mp="s4wq5prsbv8s">
              <CheckCircle2Icon className="h-5 w-5" aria-hidden="true" data-id="element-158" data-mp="28mas27vdts2y" />
            </span>
            <p className="min-w-0 text-[11px] font-semibold leading-snug text-white" data-id="element-159" data-mp="23nhao4cz5gxi">
              <span className="font-bold text-cyan" data-id="element-160" data-mp="2aobgkvh5af07">{buyer.name}</span> just
              purchased AUTOMOTIVE DIAGNOSTIC PRO™
              <span className="mt-0.5 block font-mono text-[10px] font-medium uppercase tracking-wide text-white/60" data-id="element-161" data-mp="2kmr6iv4fri84">
                {buyer.city} · {buyer.country}
              </span>
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="ml-auto shrink-0 rounded p-1 text-white/50 transition-colors duration-150 hover:text-white" data-id="element-162" data-mp="1ry3i4qoe4cqc">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-163" data-mp="21u6h5nny3v92" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}